import { AudienceTypeOptions as AudienceTypeOptionsType } from '../../../../util/demographics';

import Checkbox from 'components/common/forms/Checkbox';

export const AudienceTypeOption = ({
  currentValue,
  disabled = false,
  label,
  onChange,
  optionValue,
}: {
  currentValue: AudienceTypeOptionsType;
  disabled?: boolean;
  label: string;
  onChange(value: AudienceTypeOptionsType): void;
  optionValue: AudienceTypeOptionsType;
}): JSX.Element => {
  return (
    <div className="flex">
      <Checkbox
        checked={currentValue === optionValue}
        disabled={disabled}
        label={label}
        name="audienceProfile.audienceType"
        onChange={(event) => {
          if (event.currentTarget.checked) {
            onChange(optionValue);
          }
        }}
        radio={true}
      />
    </div>
  );
};
